import { Box, Header, Text } from '@rbilabs/universal-components';

import Link from 'components/link';
import {
  ModalContent as OriginalModalContent,
  ModalHeading as OriginalModalHeading,
} from 'components/modal';
import { SAFE_AREA_TOP_INSET } from 'components/modal/constants';
import Picture from 'components/picture';

const HEADER_HEIGHT = '150px';

export const StyledLink = Link.withConfig({
  marginTop: '$8',
  marginBottom: '$12',
  isInline: false,
  isUnderlined: true,
  _text: {
    variant: 'copyOne',
    color: Styles.color.grey.one,
    fontSize: 'sm',
    lineHeight: 'sm',
  },
});

export const Title = Header.withConfig({
  variant: 'headerTwo',
  color: Styles.color.grey.one,
});

export const Inner = Box.withConfig({
  flexDirection: 'column',
  alignItems: 'center',
  width: '90%',
  paddingTop: '$5',
  marginY: '0',
  marginX: 'auto',
  color: Styles.color.background,
});

export const ModalContent = OriginalModalContent.withConfig({
  height: 'full',
  width: 'full',
});

export const LocationContainer = Box.withConfig({
  shadow: '1',
  borderRadius: Styles.borderRadius,
  paddingY: '$4',
  paddingX: '$8',
  width: 'full',
  backgroundColor: Styles.color.cardBackground,
});

export const StreetAddress = Text.withConfig({
  variant: 'copyOne',
  fontSize: 'lg',
  lineHeight: 'md',
  fontWeight: 'bold',
});

export const Address = Text.withConfig({
  variant: 'copyOne',
  textTransform: 'capitalize',
});

export const ModalHeading = OriginalModalHeading.withConfig({
  width: 'full',
  padding: '0',
  height: HEADER_HEIGHT,
  _android: { marginTop: -SAFE_AREA_TOP_INSET },
  _web: { marginTop: -SAFE_AREA_TOP_INSET },
});

export const MapContainer = Box.withConfig({
  height: HEADER_HEIGHT,
  padding: '0',
  margin: '0',
});

export const StyledPicture = Picture.withConfig({
  height: HEADER_HEIGHT,
  width: 'full',
});
